import {Component, Input, OnInit} from '@angular/core';
import {ISickDay} from '@app/core/interfaces/sick-days.interface';
import {EQOColor, EQOIcon, EQORebrandColor, EQORebrandIcon, EQOScreenSize} from '@quickorder/angular-web-lib';
import {AuthService} from '@app/core/services/auth.service';
import {Observable} from 'rxjs';
import {User} from '@app/core/models/user.model';
import {Store} from '@ngrx/store';
import {IAppState} from '@app/core/store/state/app.state';
import {selectUser} from '@app/core/store/selectors/session.selectors';
import {
	DeleteSickDay,
	OpenEmployeeSickDayAnswerModal,
	OpenSickDayAnswersModal,
} from '@app/core/store/actions/sick-days.actions';

@Component({
	selector: 'app-sick-days-table',
	templateUrl: './sick-days-table.component.html',
	styleUrls: ['./sick-days-table.component.scss'],
})
export class SickDaysTableComponent implements OnInit {

	public ICON = EQOIcon;
	public COLOR = EQOColor;
	public SCREEN = EQOScreenSize;
	public EQORebrandIcon: typeof EQORebrandIcon = EQORebrandIcon;
	public EQORebrandColor: typeof EQORebrandColor = EQORebrandColor;

	@Input() public sickDays: ISickDay[] = [];

	public user$: Observable<User> = this.store.select(selectUser);

	constructor(
		private store: Store<IAppState>,
		public authService: AuthService,
	) {
	}

	public ngOnInit(): void {

	}

	public viewAnswers(sickDay: ISickDay): void {
		this.store.dispatch(new OpenSickDayAnswersModal(sickDay));
	}

	public answer(sickDay: ISickDay): void {
		this.store.dispatch(new OpenEmployeeSickDayAnswerModal(sickDay));
	}

	public deleteSickDay(sickDay: ISickDay): void {
		this.store.dispatch(new DeleteSickDay(sickDay));
	}
}
